import { createContext, type Dispatch, type SetStateAction } from "react";

export const FilterContext = createContext<
  [isFilterOn: boolean, setIsFilterOn: Dispatch<SetStateAction<boolean>>]
>([false, () => {}]);
FilterContext.displayName = "FilterContext";
